import CAOA1040ResponseModel from '../../../api/data/CAO/CAOG1040/CAOG1040ResponseModel'

import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'

// @ts-ignore
import { qaInfoLst, catInfoLst } from './CAOG1040ViewModel'

export default class CAOG1040Service {
  /**
   * CAOA1030 API呼出処理
   * @returns response model
   */
  public async callAPICAAOA1040(): Promise<CAOA1040ResponseModel> {
    const caoa1040ResponseModel: CAOA1040ResponseModel = <
      CAOA1040ResponseModel
    > await RestService.post(ApiUrlConstants.CAOA1040, {})
    return caoa1040ResponseModel
  }

  /**
   * カテゴリ名情報取得
   * @param searchCategoryId
   * @param catInfoLstData
   * @returns string
   */
  public getCategoryNameById(
    searchCategoryId: number,
    catInfoLstData: Array<catInfoLst>
  ): string {
    let searchCategory = ''
    catInfoLstData.forEach((x) => {
      if (x.classId === searchCategoryId) {
        searchCategory = x.classMei
      }
    })

    return searchCategory
  }

  /**
   * 質問一覧フィルタ
   * @param searchCategoryId
   * @param qaInfoLstData
   * @param searchKeyword
   * @returns Array
   */
  public filterQuestion(
    searchCategoryId: number,
    qaInfoLstData: Array<qaInfoLst>,
    searchKeyword: string
  ): Array<qaInfoLst> {
    let faqFilterCategoryLst: qaInfoLst[] = []
    let faqFilterLst: qaInfoLst[] = []

    if (searchCategoryId) {
      const qaInfo = Object.values(qaInfoLstData || {}).filter(
        (x) => x.classId === searchCategoryId
      )
      faqFilterCategoryLst.push(...qaInfo)
    } else {
      faqFilterCategoryLst = JSON.parse(JSON.stringify(qaInfoLstData))
    }

    if (searchKeyword) {
      faqFilterCategoryLst.forEach((x) => {
        if (
          x?.title?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
          x?.memo?.toLowerCase().includes(searchKeyword.toLowerCase())
        ) {
          faqFilterLst.push(x)
        }
      })
    } else {
      faqFilterLst = JSON.parse(JSON.stringify(faqFilterCategoryLst))
    }

    return faqFilterLst?.map((item) => {
      item.id = Math.random().toString()
      return {
        ...item
      }
    })
  }
}
